import { useQuery } from "react-query";
import { IResponse } from "../../../interfaces/response";
import { ILockReason } from "./useGetLockReasons";

// TODO: Replace with actual API call when endpoint is available
const DUMMY_UNLOCK_REASONS: ILockReason[] = [
  { id: 1, reason: "Issue resolved" },
  { id: 2, reason: "Identity verified" },
  { id: 3, reason: "User request approved" },
  { id: 4, reason: "Administrative unlock" },
  { id: 5, reason: "Other" },
];

const getUnlockReasons = async (): Promise<IResponse<ILockReason[]>> => {
  return {
    data: DUMMY_UNLOCK_REASONS,
    message: "Success",
    status: true,
    status_code: 200,
  };
};

export default function useGetUnlockReasons() {
  return useQuery<IResponse<ILockReason[]>, Error>(
    ["getUnlockReasons"],
    getUnlockReasons,
    {
      refetchOnWindowFocus: false,
    },
  );
}
